<template>
  <v-container class="access-keys-page" fluid>
    <div class="access-keys-header">
      <h1 class="access-keys-header__title">{{ $route.meta.title }}</h1>
      <div class="access-keys-header__actions">
        <v-menu v-if="isRoleNameAdmin" bottom left offset-y transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              outlined
              class="access-keys-header__btn text-none"
              dark
              rounded
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-download-outline</v-icon>
              Скачать отчёт
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item disabled>
              <v-list-item-title>Полный отчёт</v-list-item-title>
            </v-list-item>
            <v-list-item @click="dialogReport = true">
              <v-list-item-title>Отчёт на странице</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="$checkPermission('create_key')"
          color="primary"
          class="access-keys-header__btn text-none"
          dark
          rounded
          :to="{ path: '/access-key/new', query: $route.query }"
        >
          <v-icon left>mdi-key-plus</v-icon>
          Новый ключ
        </v-btn>
      </div>
    </div>

    <div class="access-keys-tabs-wrap mt-3">
      <v-tabs v-model="activeTab" class="access-keys-tabs" grow>
        <v-tab class="access-keys-tab">Ключи доступа</v-tab>
        <v-tab class="access-keys-tab">Универсальные ключи</v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="activeTab" class="access-keys-tabs-items">
      <!-- Таб: Ключи доступа -->
      <v-tab-item>
        <v-card class="access-keys-block mt-3" flat outlined>
          <div class="access-keys-filters">
            <div class="access-keys-filters__title">
              <v-icon left small>mdi-filter-variant</v-icon>
              Фильтры
            </div>
            <div class="access-keys-filters__switches-row">
              <div class="access-keys-filters__switches">
                <v-switch
                  v-if="roleName === 'admin' || roleName === 'manager'"
                  v-model="isDuplicateKeys"
                  @change="showFiltersKeys()"
                  class="access-keys-filters__switch"
                  color="primary"
                  hide-details
                  dense
                  label="Скрыть дубликаты ключей"
                />
                <v-switch
                  v-model="freeKeysDoorphone"
                  @change="showFiltersKeys()"
                  class="access-keys-filters__switch"
                  color="primary"
                  hide-details
                  dense
                  label="Показать свободные ключи"
                />
              </div>
              <v-btn color="primary" class="text-none access-keys-filters__search-btn" dark rounded @click.prevent="filterKeys">
                <v-icon left>mdi-magnify</v-icon>
                Поиск
              </v-btn>
            </div>
            <div class="access-keys-filters__row">
              <v-text-field
                v-model="simpleFilterName"
                placeholder="Имя"
                outlined
                dense
                hide-details
                clearable
                class="access-keys-filters__field"
                prepend-inner-icon="mdi-rename-box-outline"
                @keyup.enter="filterKeys()"
              />
              <v-text-field
                v-model="simpleFilterCode"
                placeholder="Код"
                outlined
                dense
                hide-details
                clearable
                class="access-keys-filters__field"
                prepend-inner-icon="mdi-key-outline"
                @keyup.enter="filterKeys()"
              />
              <v-menu
                v-model="menuFilterDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="190px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="dateRangeFilter"
                    placeholder="Промежуток времени"
                    outlined
                    dense
                    hide-details
                    readonly
                    class="access-keys-filters__field access-keys-filters__field--date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="dateFilter" range :max="today">
                  <v-spacer />
                  <v-btn text color="primary" @click="menuFilterDate = false">Назад</v-btn>
                  <v-btn text color="primary" :disabled="!dateFilter || !dateFilter[0]" @click="dateFilter = []">Сбросить</v-btn>
                  <v-btn text color="primary" @click="menuFilterDate = false">Выбрать</v-btn>
                </v-date-picker>
              </v-menu>
              <v-autocomplete
                v-model="filterAgent"
                placeholder="Агент"
                :items="agents"
                item-text="user.name"
                item-value="id"
                class="access-keys-filters__field"
                prepend-inner-icon="mdi-account-search"
                outlined
                dense
                hide-details
                clearable
              />
              <v-autocomplete
                v-model="filterAuthorName"
                placeholder="Автор ключа"
                :items="authors"
                item-text="name"
                item-value="id"
                class="access-keys-filters__field"
                prepend-inner-icon="mdi-account"
                outlined
                dense
                hide-details
                clearable
                @keyup.enter="filterKeys()"
              />
            </div>
          </div>
          <v-divider class="my-0" />
          <v-progress-linear v-if="loading" indeterminate color="primary" class="my-0" />
          <v-data-table
            class="table"
            :headers="headersSimpleKey"
            :items="simpleKeys"
            :options.sync="options"
            :server-items-length="simpleTotalKeys"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 50, 100, 500],
              showFirstLastPage: true,
            }"
            disable-sort
          >
            <template v-slot:item.createdAt="{ item }">
              {{ ruDateFormat(item.created_at) }}
            </template>
            <template v-slot:item.doorphone="{ item }">
              <router-link v-if="item.doorphones[0]" class="routerLink" :to="`/doorphones/${item.doorphones[0].id}`">
                <span class="my-link">{{ getDoorphoneAddress(item.doorphones[0]) }}</span>
              </router-link>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row justify="center" class="flex-nowrap">
                <v-tooltip v-if="$checkPermission('update_key')" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      text
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="btn__icon pa-0 mr-1"
                      width="18"
                      height="18"
                      :to="simpleKeyEditLink(item.id)"
                    >
                      <v-icon size="large">mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Редактировать</span>
                </v-tooltip>
                <v-tooltip v-if="$checkPermission('destroy_key')" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      text
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="btn__icon pa-0"
                      width="18"
                      height="18"
                      @click.stop="$set(dialog, item.id, true)"
                    >
                      <v-icon size="large">mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Удалить</span>
                </v-tooltip>
                <v-dialog
                  v-model="dialog[item.id]"
                  max-width="350"
                  content-class="dialog-border-radius"
                  persistent
                  :retain-focus="false"
                >
                  <baseDeleteModal
                    :active.sync="dialog[item.id]"
                    @close="$set(dialog, item.id, false)"
                    @submit="removeKey(item.id)"
                    messageTitle="Удалить ключ?"
                    messageText="Подтверждая, вы удалите ключ."
                    confirm-text="Удалить"
                    confirm-color="error"
                  />
                </v-dialog>
              </v-row>
            </template>
          </v-data-table>
        </v-card>

        <v-dialog v-model="dialogReport" :retain-focus="false" max-width="420" content-class="dialog-border-radius" persistent>
          <v-card>
            <v-card-title class="access-keys-dialog-report__title">Отчёт на странице ключей</v-card-title>
            <v-card-text>
              <v-menu
                v-model="menuDateTimeAccessKey"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-x
                min-width="190px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="metDateTime"
                    label="Промежуток времени (месяц)"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    prepend-inner-icon="mdi-calendar"
                  />
                </template>
                <v-date-picker v-model="dateAccessKey" :max="maxYearMonth" :landscape="landscape" type="month" @change="menuDateTimeAccessKey = false">
                  <v-spacer />
                  <v-btn text color="primary" @click="menuDateTimeAccessKey = false">Назад</v-btn>
                  <v-btn text color="primary" :disabled="dateAccessKey === ''" @click="dateAccessKey = ''">Сбросить</v-btn>
                  <v-btn text color="primary" @click="menuDateTimeAccessKey = false">Выбрать</v-btn>
                </v-date-picker>
              </v-menu>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text color="grey" @click="dialogReport = false">Отмена</v-btn>
              <v-btn color="primary" text @click="downloadReportPage()">Скачать</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <!-- Таб: Универсальные ключи -->
      <v-tab-item>
        <v-snackbar v-model="snackbar" bottom color="info" timeout="4000">
          {{ snackbarText }}
        </v-snackbar>
        <v-card class="access-keys-block mt-3" flat outlined>
          <div class="access-keys-filters">
            <div class="access-keys-filters__title">
              <v-icon left small>mdi-filter-variant</v-icon>
              Фильтры
            </div>
            <div v-if="isRoleNameAdmin" class="access-keys-filters__switches-row mb-2">
              <div class="access-keys-filters__switches">
                <v-switch
                  v-model="universalUnusedOnly"
                  @change="filterUniversalKeys()"
                  class="access-keys-filters__switch"
                  color="primary"
                  hide-details
                  dense
                  label="Только без открытий (> 10 дн.)"
                />
              </div>
            </div>
            <div class="access-keys-filters__row">
              <v-text-field
                v-model="universalFilterName"
                placeholder="Имя"
                outlined
                dense
                hide-details
                clearable
                class="access-keys-filters__field"
                prepend-inner-icon="mdi-rename-box-outline"
                @keyup.enter="filterUniversalKeys()"
              />
              <v-text-field
                v-model="universalFilterCode"
                placeholder="Код"
                outlined
                dense
                hide-details
                clearable
                class="access-keys-filters__field"
                prepend-inner-icon="mdi-key-outline"
                @keyup.enter="filterUniversalKeys()"
              />
              <v-btn color="primary" class="text-none" dark rounded @click.prevent="filterUniversalKeys">
                <v-icon left>mdi-magnify</v-icon>
                Поиск
              </v-btn>
            </div>
          </div>
          <v-divider class="my-0" />
          <v-data-table
            class="table"
            :headers="filteredUniversalHeaders"
            :items="keyGroups"
            :options.sync="universalOptions"
            :server-items-length="universalTotalKeys"
            :footer-props="{
              'items-per-page-options': [5, 15, 50, 100, 500, 1000, -1],
              showFirstLastPage: true,
            }"
            disable-sort
          >
            <template v-slot:item.id="{ item }">
              <ul v-for="(keys, i) in item.keys" v-bind:key="keys.id + i">
                {{ keys.id }}
              </ul>
            </template>
            <template v-slot:item.keys_name="{ item }">
              <ul v-for="(keys, i) in item.keys" v-bind:key="keys.name + i">
                {{ keys.name }}
              </ul>
            </template>
            <template v-slot:item.createdAt="{ item }">
              <ul v-for="(keys, i) in item.keys" v-bind:key="keys.created_at + i">
                {{ ruDateFormat(keys.created_at) }}
              </ul>
            </template>
            <template v-slot:item.usage="{ item }">
              <div v-if="item.last_opened_at || usageDays(item) > 0" class="access-keys-usage">
                <div v-if="item.last_opened_at" class="access-keys-usage__date">
                  {{ ruDateFormat(item.last_opened_at) }}
                </div>
                <div
                  v-if="usageDays(item) > 0"
                  class="access-keys-usage__days"
                  :style="{ color: unusedDaysColor(usageDays(item)) }"
                >
                  {{ unusedDaysLabel(item) }}
                </div>
              </div>
            </template>
            <template v-slot:item.doorphones_count="{ item }">
              <ul v-for="(keys) in item.keys" v-bind:key="keys.doorphones_count + Math.random()">
                {{ keys.doorphones_count }}
              </ul>
            </template>
            <template v-slot:item.agent="{ item }">
              <ul v-for="(keys, i) in item.keys" v-bind:key="keys.agent_name + i">
                {{ keys.agent_name }}
              </ul>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="access-keys-universal-actions">
                <div
                  v-for="keys in item.keys"
                  :key="keys.id"
                  class="access-keys-universal-actions__row"
                >
                  <v-tooltip v-if="$checkPermission('view_key')" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="access-keys-universal-actions__btn"
                        width="32"
                        height="32"
                        min-width="32"
                        :to="universalKeyViewLink(keys.id)"
                      >
                        <v-icon small>mdi-eye-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Просмотр</span>
                  </v-tooltip>
                  <v-tooltip v-if="$checkPermission('update_key')" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="access-keys-universal-actions__btn"
                        width="32"
                        height="32"
                        min-width="32"
                        :to="universalKeyEditLink(keys.id)"
                      >
                        <v-icon small>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip v-if="$checkPermission('destroy_key')" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="access-keys-universal-actions__btn"
                        width="32"
                        height="32"
                        min-width="32"
                        :disabled="keys.doorphones_count > 80"
                        @click.stop="$set(dialogUniversal, keys.id, true)"
                      >
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                  <v-dialog
                    v-model="dialogUniversal[keys.id]"
                    max-width="400"
                    content-class="dialog-border-radius"
                    persistent
                    :retain-focus="false"
                  >
                    <baseDeleteModal
                      :active.sync="dialogUniversal[keys.id]"
                      @close="$set(dialogUniversal, keys.id, false)"
                      @submit="removeUniversalKey(keys.id)"
                      messageTitle="Удалить универсальный ключ?"
                      messageText="Подтверждая, вы удалите ключ."
                      confirm-text="Удалить"
                      confirm-color="error"
                    />
                  </v-dialog>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import cp1251Encode from '@/mixins/cp1251Encode';
import baseDeleteModal from '@/components/BaseDeleteModal';
import {
  TAB_SIMPLE,
  TAB_UNIVERSAL,
  parseAccessKeysListQuery,
  buildAccessKeysListQuery,
  accessKeyItemLocation,
} from '@/components/accessKeys/accessKeysListRoute';

const keyParse = (key) => {
  if (key.doorphones.length > 0) {
    const { address, entrance } = key.doorphones[0];
    return entrance && address
      ? {
        ...key,
        doorphones: [{
          ...key.doorphones[0],
          address: `${address}, п.${entrance}`,
        }],
      }
      : key;
  }
  return key;
};

export default {
  components: { baseDeleteModal },
  mixins: [ruDateFormatMixin, cp1251Encode],
  name: 'AccessKeys',
  data () {
    return {
      activeTab: 0,
      dialog: {},
      dialogUniversal: {},
      filters: {},
      filter: {},
      dateFilter: [],
      menuFilterDate: false,
      today: new Date().toISOString().split('T')[0],
      loading: true,
      simpleFilterCode: '',
      filterAgent: '',
      filterAuthorName: '',
      snackbar: false,
      snackbarText: '',
      simpleFilterName: '',
      universalFilterName: '',
      universalFilterCode: '',
      universalUnusedOnly: false,
      doorphoneIdFilter: '',
      include: ['doorphones,authorInfo'],
      isCreated: false,
      maxYearMonth: null,
      landscape: false,
      options: {
        page: 1,
        itemsPerPage: 20,
      },
      universalOptions: {
        page: 1,
        itemsPerPage: 15,
      },
      simpleKeys: [],
      universalTotalKeys: 0,
      simpleTotalKeys: 0,
      headersSimpleKey: [
        { text: 'id', value: 'id' },
        { text: 'Имя ключа', value: 'name' },
        { text: 'Код ключа', value: 'code' },
        { text: 'Агент', value: 'agent.user.name' },
        { text: 'Домофон', value: 'doorphone' },
        { text: 'Создания ключа', value: 'createdAt' },
        { text: 'Комментарий', value: 'comment' },
        { text: 'Автор ключа', value: 'author.name' },
        { text: '', value: 'actions' },
      ],
      headersUniversalKey: [
        { text: 'id', value: 'id' },
        { text: 'Код ключа', value: 'code' },
        { text: 'Имя ключа', value: 'keys_name' },
        { text: 'Агент', value: 'agent' },
        { text: 'Кол-во ключей', value: 'keys_count' },
        { text: 'Кол-во домофонов', value: 'doorphones_count' },
        { text: 'Создания ключа', value: 'createdAt' },
        { text: 'Использование', value: 'usage' },
        { text: '', value: 'actions' },
      ],
      popupKeyReader: false,
      freeKeysDoorphone: false,
      isDuplicateKeys: false,
      dialogReport: false,
      codeReader: '',
      dateAccessKey: '',
      menuDateTimeAccessKey: false,
      isRoleNameAdmin: false,
      suppressRouteSync: false,
    };
  },
  watch: {
    activeTab (tab) {
      if (this.suppressRouteSync) return;
      this.syncListRoute();
      if (tab === 1 && this.keyGroups.length === 0) {
        this.universalChangePage();
      }
    },
    options: {
      handler () {
        if (!this.isCreated) {
          this.changePage();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
    universalOptions: {
      handler () {
        if (!this.isCreated) {
          this.universalChangePage();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
    '$route.query': {
      handler (query) {
        if (this.suppressRouteSync) return;
        this.applyListQuery(query, { load: true });
      },
    },
  },
  created () {
    this.isCreated = true;
    this.sort = ['-id'];
    this.getKeyAuthors();

    const { activeTab, page, perPage, tab } = parseAccessKeysListQuery(this.$route.query);
    this.suppressRouteSync = true;
    this.activeTab = activeTab;
    if (tab === TAB_UNIVERSAL) {
      this.universalOptions.page = page;
      this.universalOptions.itemsPerPage = perPage;
    } else {
      this.options.page = page;
      this.options.itemsPerPage = perPage;
    }
    this.$nextTick(() => {
      this.suppressRouteSync = false;
    });

    if (tab === TAB_UNIVERSAL) {
      this.loading = false;
      this.universalChangePage();
    } else {
      this.getKeys({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: { universal: 0 },
        include: this.include,
      })
        .then((response) => {
          this.simpleKeys = response.keys.map(keyParse);
          this.simpleTotalKeys = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке ключей');
        })
        .finally(() => {
          this.loading = false;
        });
    }

    if (!this.$route.query.tab || !this.$route.query.per_page) {
      this.syncListRoute();
    }

    switch (this.roleName) {
      case 'admin' : this.isRoleNameAdmin = true;
        break;
    }
    setTimeout(() => this.$nextTick(() => {
      this.$store.commit('setLoading', false);
    }), 500);
    const newDate = new Date();
    this.maxYearMonth = newDate.getFullYear() + '-' + (newDate.getMonth() + 1);
  },
  computed: {
    ...mapGetters({
      keyGroups: 'Keys/keyGroups',
      agents: 'Agents/agents',
      authors: 'Keys/authors',
      roleName: 'roleName',
      role: 'role',
    }),
    currentListTab () {
      return this.activeTab === 1 ? TAB_UNIVERSAL : TAB_SIMPLE;
    },
    currentListPage () {
      return this.activeTab === 1 ? this.universalOptions.page : this.options.page;
    },
    currentListPerPage () {
      return this.activeTab === 1
        ? this.universalOptions.itemsPerPage
        : this.options.itemsPerPage;
    },
    dateRangeFilter () {
      let formattedStartDate = '';
      let formattedEndDate = '';
      if (this.dateFilter[0]) {
        formattedStartDate = this.ruDateFormat(this.dateFilter[0], true);
      }
      if (this.dateFilter[1]) {
        formattedEndDate = ` - ${this.ruDateFormat(this.dateFilter[1])}`;
      }

      return `${formattedStartDate}${formattedEndDate}`;
    },
    metDateTime () {
      if (this.dateAccessKey) {
        const date = new Date(this.dateAccessKey);
        const options = { year: 'numeric', month: 'long' };
        return date.toLocaleDateString(undefined, options);
      } else {
        return '';
      }
    },
    filteredHeaders () {
      if (+this.role === 2) {
        return this.headersSimpleKey.filter(item => {
          return item.value !== 'agent.user.name';
        });
      } else {
        return this.headersSimpleKey;
      }
    },
    filteredUniversalHeaders () {
      if (this.isRoleNameAdmin) {
        return this.headersUniversalKey;
      }
      return this.headersUniversalKey.filter((item) => item.value !== 'usage');
    },
  },
  methods: {
    ...mapActions({
      getUniversalKeyGroups: 'Keys/getUniversalKeyGroups',
      getKeys: 'Keys/getKeys',
      loadAllAgents: 'Agents/loadAllAgents',
      deleteKey: 'Keys/deleteKey',
      getKeyAuthors: 'Keys/getKeyAuthors',
    }),
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.type === 'G') {
        address += ' (калитка)';
      }
      if (doorphone.type === 'A') {
        address += ' (доп.вход)';
      }
      return address;
    },
    usageDays (item) {
      if (item.last_opened_at) {
        const from = new Date(item.last_opened_at);
        if (Number.isNaN(from.getTime())) {
          return Number(item.unused_days) || 0;
        }
        const now = new Date();
        from.setHours(0, 0, 0, 0);
        now.setHours(0, 0, 0, 0);
        return Math.max(0, Math.round((now - from) / 86400000));
      }
      return Number(item.unused_days) || 0;
    },
    unusedDaysLabel (item) {
      const unusedDays = this.usageDays(item);
      if (unusedDays <= 0) {
        return '';
      }
      if (!item.last_opened_at) {
        return `нет открытий ≥ ${unusedDays} дн.`;
      }
      return `${unusedDays} дн. без открытий`;
    },
    unusedDaysColor (days) {
      const unusedDays = Number(days) || 0;
      if (unusedDays <= 0) {
        return '#43A047';
      }
      if (unusedDays < 15) {
        return '#F9A825';
      }
      if (unusedDays < 30) {
        return '#FB8C00';
      }
      return '#E53935';
    },
    simpleKeyEditLink (id) {
      return accessKeyItemLocation(id, {
        tab: TAB_SIMPLE,
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        edit: true,
      });
    },
    universalKeyViewLink (id) {
      return accessKeyItemLocation(id, {
        tab: TAB_UNIVERSAL,
        page: this.universalOptions.page,
        perPage: this.universalOptions.itemsPerPage,
        edit: false,
      });
    },
    universalKeyEditLink (id) {
      return accessKeyItemLocation(id, {
        tab: TAB_UNIVERSAL,
        page: this.universalOptions.page,
        perPage: this.universalOptions.itemsPerPage,
        edit: true,
      });
    },
    syncListRoute () {
      const query = buildAccessKeysListQuery({
        tab: this.currentListTab,
        page: this.currentListPage,
        perPage: this.currentListPerPage,
      });
      if (
        this.$route.query.tab === query.tab && String(this.$route.query.page || '1') === query.page && String(this.$route.query.per_page || '') === query.per_page
      ) {
        return;
      }
      this.suppressRouteSync = true;
      this.$router.replace({ name: 'Access-keys', query }).catch(() => {}).finally(() => {
        this.$nextTick(() => {
          this.suppressRouteSync = false;
        });
      });
    },
    applyListQuery (query, { load = false } = {}) {
      const { activeTab, page, perPage, tab } = parseAccessKeysListQuery(query);
      const tabChanged = this.activeTab !== activeTab;
      const pageChanged = tab === TAB_UNIVERSAL
        ? this.universalOptions.page !== page
        : this.options.page !== page;
      const perPageChanged = tab === TAB_UNIVERSAL
        ? this.universalOptions.itemsPerPage !== perPage
        : this.options.itemsPerPage !== perPage;

      if (!tabChanged && !pageChanged && !perPageChanged) {
        return;
      }

      this.suppressRouteSync = true;
      this.isCreated = true;
      this.activeTab = activeTab;
      if (tab === TAB_UNIVERSAL) {
        this.universalOptions = {
          ...this.universalOptions,
          page,
          itemsPerPage: perPage,
        };
      } else {
        this.options = {
          ...this.options,
          page,
          itemsPerPage: perPage,
        };
      }
      this.$nextTick(() => {
        this.suppressRouteSync = false;
        this.isCreated = false;
        if (load) {
          if (tab === TAB_UNIVERSAL) {
            this.universalChangePage();
          } else {
            this.changePage();
          }
        }
      });
    },
    filterKeys () {
      this.options.page = 1;
      this.changePage();
    },
    filterUniversalKeys () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    loadKeys () {
      this.getKeys({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: this.filters,
        include: this.include,
      })
        .then((response) => {
          this.simpleKeys = response.keys.map(keyParse);
          this.simpleTotalKeys = response.meta.total;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка при загрузке ключей доступа');
        });
    },
    loadUniversalKeys () {
      this.getUniversalKeyGroups({
        page: this.universalOptions.page,
        limit: this.universalOptions.itemsPerPage,
        filters: this.filter,
      })
        .then((response) => {
          this.universalTotalKeys = response.meta.total;
        });
    },
    downloadReportPage () {
      const lines = [];
      const link = document.createElement('a');

      const formatLine = (item) => {
        const agentName = item?.agent?.user?.name || '';
        return [
          item.id, item?.name, item?.code, agentName,
          item?.doorphones[0]?.address, item.created_at, item?.comment, item?.author?.name || '',
        ].join(';');
      };

      this.simpleKeys.forEach((item) => {
        lines.push(formatLine(item));
      });

      if (this.dateAccessKey) {
        const filteredLines = lines.filter((line) => {
          const lineParts = line.split(';');
          const lineCreatedAt = lineParts[5];
          return lineCreatedAt.startsWith(this.dateAccessKey);
        });

        if (filteredLines.length > 0) {
          const formattedLines = filteredLines.map((line) => {
            const lineParts = line.split(';');
            lineParts[5] = this.ruDateFormat(lineParts[5]); // дата находится на шестой позиции в строке
            return lineParts.join(';');
          });

          link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(formattedLines.join('\n'))}`;
          this.triggerDownload(link, `Report-keys-${this.dateAccessKey}.csv`);
          this.dateAccessKey = '';
          this.dialogReport = false;
        } else {
          this.$flash_danger('Нет совпадений с выбранной датой');
        }
      } else {
        const formattedLines = lines.map((line) => {
          const lineParts = line.split(';');
          lineParts[5] = this.ruDateFormat(lineParts[5]); // дата находится на шестой позиции в строке
          return lineParts.join(';');
        });

        link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(formattedLines.join('\n'))}`;
        this.triggerDownload(link, 'keys.csv');
        this.dialogReport = false;
      }
    },
    triggerDownload (link, fileName) {
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    changePage () {
      this.filters.universal = 0;

      if (this.dateFilter[0]) {
        this.filters.date_from = this.dateFilter[0];
      } else {
        delete this.filters.date_from;
      }
      if (this.dateFilter[1]) {
        this.filters.date_to = this.dateFilter[1];
      } else {
        delete this.filters.date_to;
      }
      if (this.simpleFilterCode) {
        this.filters.code = this.simpleFilterCode;
      } else {
        delete this.filters.code;
      }

      if (this.filterAgent) {
        this.filters.agent_id = this.filterAgent;
      } else {
        delete this.filters.agent_id;
      }

      if (this.filterAuthorName) {
        this.filters.author = this.filterAuthorName;
      } else {
        delete this.filters.author;
      }

      if (this.simpleFilterName) {
        this.filters.name = this.simpleFilterName;
      } else {
        delete this.filters.name;
      }

      if (this.freeKeysDoorphone) {
        this.filters.doorphone_id = 'null';
      } else {
        delete this.filters.doorphone_id;
      }

      if (this.isDuplicateKeys) {
        this.filters.hide_duplicates = 1;
      } else {
        delete this.filters.hide_duplicates;
      }
      this.loadKeys();
      this.syncListRoute();
    },
    universalChangePage () {
      if (this.universalFilterName) {
        this.filter.name = this.universalFilterName;
      } else {
        delete this.filter.name;
      }
      if (this.universalFilterCode) {
        this.filter.code = this.universalFilterCode;
      } else {
        delete this.filter.code;
      }
      if (this.isRoleNameAdmin && this.universalUnusedOnly) {
        this.filter.unused = 1;
      } else {
        delete this.filter.unused;
      }
      this.loadUniversalKeys();
      this.syncListRoute();
    },
    removeKey (idKey) {
      this.deleteKey(idKey)
        .then(() => {
          this.$flash_success('Ключ удалён');
          this.dialog[idKey] = false;
          this.getKeys({
            pagination: 1,
            page: this.options.page,
            limit: this.options.itemsPerPage,
            filters: { universal: 0 },
            include: this.include,
          })
            .then((response) => {
              this.simpleKeys = response.keys.map(keyParse);
              this.simpleTotalKeys = response.meta.total;
            });
        })
        .catch((message) => {
          if (message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при удалении ключа');
          }
          this.dialog[idKey] = false;
        });
    },
    removeUniversalKey (idKey) {
      this.snackbarText = 'Идет удаление ключа, это займет немного времени...';
      this.snackbar = true;
      this.deleteKey(idKey)
        .then(() => {
          this.$flash_success('Ключ удалён');
          this.snackbarText = 'Ключ успешно удален.';
          this.dialogUniversal[idKey] = false;
          this.getUniversalKeyGroups({
            page: this.universalOptions.page,
            limit: this.universalOptions.itemsPerPage,
            filters: this.filter,
          })
            .then((response) => {
              this.universalTotalKeys = response.meta.total;
            });
        })
        .catch((message) => {
          if (message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при удалении ключа');
          }
          this.dialogUniversal[idKey] = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.snackbar = false;
          }, 1000);
        });
    },
    showFiltersKeys () {
      this.options.page = 1;
      this.changePage();
    },
  },
};
</script>

<style lang="scss" scoped>
.access-keys-page {
  padding: 24px;
}

.access-keys-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.access-keys-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.access-keys-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.access-keys-header__btn {
  text-transform: none;
  font-weight: 500;
}

.access-keys-tabs-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px 12px 0 0;
  border-bottom: none;
  overflow: hidden;
}

.access-keys-tabs {
  box-shadow: none;
}

.access-keys-tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.access-keys-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
}

.access-keys-tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.access-keys-tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.access-keys-tabs ::v-deep .v-tabs-bar .v-tab:not(.v-tab--active):hover {
  color: #37474f;
}

.access-keys-tabs-items {
  background: transparent;
}

.access-keys-block {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
}

.access-keys-page .access-keys-tabs-wrap + .access-keys-tabs-items .access-keys-block {
  border-radius: 0 0 12px 12px;
}

.access-keys-filters {
  padding: 20px 20px 24px;
}

.access-keys-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 12px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.access-keys-filters__switches-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.access-keys-filters__switches {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px 24px;
}

.access-keys-filters__switch {
  margin: 0;
}

.access-keys-filters__search-btn {
  flex-shrink: 0;
}

.access-keys-filters__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.access-keys-filters__field {
  max-width: 320px;
  width: 100%;
  min-width: 200px;
}

.access-keys-filters__field--date {
  max-width: 360px;
}

.access-keys-dialog-report__title {
  font-size: 1.1rem;
  font-weight: 600;
}
.access-keys-usage {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  line-height: 1.25;
  padding: 4px 0;
}

.access-keys-usage__date {
  font-size: 0.8125rem;
  color: #455a64;
}

.access-keys-usage__days {
  font-size: 0.8125rem;
}

.access-keys-universal-actions__row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 1px;
  margin-bottom: 1px;
}

.access-keys-universal-actions__row:last-child {
  margin-bottom: 0;
}

.access-keys-universal-actions__btn {
  flex-shrink: 0;
}

.routerLink {
  text-decoration: none;
}

.v-application .my-link,
.my-link {
  color: #434850;
}

.my-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .access-keys-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .access-keys-header__title {
    font-size: 1.4rem;
  }

  .access-keys-filters__field {
    max-width: none;
  }

  .access-keys-filters__switches-row {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
